import { IWidgetConfigurationProps } from "@sgwt-widget/core";
import { ApiBackedComponent } from "../components/ApiBackedComponent";
import {
  MakeAirRetentionRateCall,
  MakeSalesCreditRoleProfile,
} from "../generic/generic-api";
import { GenericFilterBuilder } from "../generic/generic-helper";
import { SCAttributes } from "../generic/generic-sc-attributes";
import { SCKpis } from "../generic/generic-sc-domain";
import {
  IGenericAggregateResponse,
  IGenericRequest,
} from "../generic/generic-types";
import { ConvertFilter, areFiltersCompatible } from "./salescredit-filter-help";
import { SCProfileDictionary } from "./salescredit-profile-dictionary";
import {
  BuildSalesCreditFilters,
  CreateDateFromFilter,
} from "./salescredit-search-criteria";
import { IProps } from "./salescredit-types";

export abstract class SalesCreditBvRetetionHelper<
  TState
> extends ApiBackedComponent<IProps & IWidgetConfigurationProps, TState> {
  protected constructor() {
    super();
  }

  protected async fetchApiData(props: IProps) {
    this.initCorrelationId();
    this.setDataStatus("loading");
    const userRole = await MakeSalesCreditRoleProfile(
      props.headers,
      this.props.widgetConfiguration,
      undefined,
      this.state.correlationId
    );

    if (userRole.Role === undefined) {
      this.setDataStatus("no-access-rights");
      this.setStatusText(userRole.StatusText);
      return;
    }

    const indicator = "sc";
    const attributes = `${SCAttributes.SC_FPV_TRADE_NEGO_ENTITY_REGION},${SCAttributes.SC_FPV_TRADE_PC},${SCAttributes.SC_FPV_TRADE_LABEL},${SCAttributes.SC_FPV_TRADE_BUMNEMO}`;
    const sortOrder = "-sc_ytd";
    const headers = props.headers;

    const filtersConverted = ConvertFilter(props.filters);
    const compatible = areFiltersCompatible(filtersConverted);
    if(compatible && !compatible.valid) {
      this.setDataStatus("incompatible-filters-error");
      this.setStatusText(compatible.attribute);
      return;
    }

    const filters = BuildSalesCreditFilters(filtersConverted);
    const profileDictionary = new SCProfileDictionary();
    const kpis = profileDictionary.GetKpi(userRole.Profile, SCKpis.SC_YTD);
    const finalFilter = GenericFilterBuilder(filters)
      ? GenericFilterBuilder(filters)
      : "";
    const asOfDate = CreateDateFromFilter(filtersConverted);
    const genericRequest: IGenericRequest = {
      aggregationAttributes: attributes,
      date: asOfDate,
      filter: finalFilter,
      kpis,
      sort: sortOrder,
    };

    const responseData = await MakeAirRetentionRateCall(
      headers,
      indicator,
      genericRequest,
      this.props.widgetConfiguration,
      this.state.correlationId
    );

    this.ProcessData(responseData);
  }
  protected abstract renderWithDataReady(): JSX.Element;
  protected abstract ProcessData(responseData: IGenericAggregateResponse): void;
}
